import styled from 'styled-components';

export const SurveyContainer = styled.div`
  iframe {
    width: 100%;
    max-width: 100%;
    height: calc(100vh - 300px);
    border: none;
  }
`;
